import { Col, Form, Input, Row } from 'antd';
import { Container } from '@/components/Container';
import { InputNumber } from '@/components/input/InputNumber';

export function ProdutoTabCaracteristicas() {
    return (
        <Container>
            <Row gutter={[8, 8]}>
                <Col md={8} sm={12} xs={12}>
                    <Form.Item className='mb-3' label='Largura (cm)' name='pro_largura'>
                        <InputNumber decimalScale={2} />
                    </Form.Item>
                </Col>

                <Col md={8} sm={12} xs={12}>
                    <Form.Item className='mb-3' label='Altura (cm)' name='pro_altura'>
                        <InputNumber decimalScale={2} />
                    </Form.Item>
                </Col>

                <Col md={8} sm={12} xs={12}>
                    <Form.Item className='mb-3' label='Comprimento (cm)' name='pro_comprimento'>
                        <InputNumber decimalScale={2} />
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item label='Descrição / Composição do produto' name='pro_composicao'>
                        <Input.TextArea rows={8} />
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col md={8} sm={12} xs={24}>
                    <Form.Item className='mb-3' label='Observações' name='pro_observacao'>
                        <Input.TextArea rows={3} />
                    </Form.Item>
                </Col>
            </Row>
        </Container>
    );
}
